import {Component, Input, OnInit} from '@angular/core';
import {CommonService} from 'src/app/modules/shared/services/common.service';
import {
  AddDailyMealComponent
} from '../add-daily-meal/add-daily-meal.component';
import {Store} from '@ngrx/store';
import {DeleteMyJOurnalRecordsRequest} from '../../core/my-journal.actions';
import {Subject, takeUntil} from 'rxjs';
import {GetDailyMealsList} from '../../core/my-journal.selector';

@Component({
  selector: 'app-daily-meal-drink-tracker',
  templateUrl: './daily-meal-drink-tracker.component.html',
  styleUrls: ['./daily-meal-drink-tracker.component.css']
})
export class DailyMealDrinkTrackerComponent implements OnInit {
  @Input() selectedDate;
  @Input() memberId;
  @Input() groupId;
  expandPanel: any = true;
  dataSource = []
  loading: boolean = false;

  colDef = [
    'mealTime',
    'myFood',
    'amounts',
    'lightCount',
    'comments',
    'actions'
  ]
  totalRl;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private commonService: CommonService, private store: Store) {
  }

  ngOnInit() {
    this.store.select(GetDailyMealsList).pipe(takeUntil(this.onDestroy))
      .subscribe(meals => {
        this.loading = meals.loading;
        this.dataSource = meals.list;
        this.totalRl = meals.totalRl;
      });
  }

  addDailyMeal() {
    const addFood = this.commonService.openDialog({
      data: {
        component: AddDailyMealComponent,
        data: {memberId: this.memberId, selectedDate: this.selectedDate, groupId: this.groupId},
      },
      panelWidth: 80,
    })
  }

  onEditClicked(data: any) {
    const addFood = this.commonService.openDialog({
      data: {
        component: AddDailyMealComponent,
        data: {memberId: this.memberId, selectedDate: this.selectedDate, groupId: this.groupId},
        previousData: data
      },
      panelWidth: 80,
    })
  }

  onDeleteRecord(data) {
    this.store.dispatch(DeleteMyJOurnalRecordsRequest({
      payload: {
        ...(this.memberId ? {memberId: this.memberId} : {}),
        selectedDate: this.selectedDate,
        recordId: data.id,
        recordType: 1
      }
    }))
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
